// extracted by mini-css-extract-plugin
export default {"inputStyles":"Input_inputStyles__Qig+2","inputSize":"Input_inputSize__lmliN","inputBlack":"Input_inputBlack__2O9BM"};